import React, { useContext, useState, useEffect } from 'react';
import { auth, signIn } from '../api/firebase';

const AuthContext = React.createContext();

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    const login = (email, password) => {
        return signIn(auth, email, password);
    };

    useEffect(() => {
        const unsub = auth.onAuthStateChanged((user) => {
            setCurrentUser(user);
            if (user != null) {
                setIsAuthenticated(true);
            }
            setLoading(false);
        });

        return unsub;
    }, []);

    const value = {
        currentUser,
        isAuthenticated,
        login: login,
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
}
